import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bc30d87"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row row-cols-1 row-cols-md-2 mt-4" }
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = { class: "flex-fill" }
const _hoisted_4 = { class: "flex-fill mt-4" }
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "mt-4" }

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useDashboardPage } from "@/modern/composables/useDashboardPage";
import { usePatentSystem } from "@/modern/composables/usePatentSystem";
import TopSection from "@/modern/components/dashboard/TopSection.vue";
import MidSection from "@/modern/components/dashboard/MidSection.vue";
import BottomSection from "@/modern/components/dashboard/BottomSection.vue";
import UpgradeMembershipBanner from "@/modern/components/dashboard/UpgradeMembershipBanner.vue";
import NewEventBanner from "@/modern/components/dashboard/NewEventBanner.vue";
import BlackFridayBanner from "@/modern/components/dashboard/BlackFridayBanner.vue";
import WelcomeModal from "@/modern/components/dashboard/WelcomeModal.vue";
import UserProfileCard from "../components/dashboard/UserProfileCard.vue";
import ContinuePathwayCard from "../components/dashboard/ContinuePathwayCard.vue";
import AbilitiesRadarCard from "../components/dashboard/AbilitiesRadarCard.vue";
import MachinesCard from "../components/dashboard/MachinesCard.vue";
import NextEventCard from "../components/dashboard/NextEventCard.vue";
import GoalsCard from "../components/dashboard/GoalsCard.vue";
import ProgressiveDiscountCard from "../components/dashboard/ProgressiveDiscountCard.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const { user, userPublic, currentLanguage, lastMachine, freeWeekMachine, nextEvent, progressiveDiscount, loading } = useDashboardPage();

const publicScore = computed(() => Number(userPublic.value?.score?.value ?? 0));
const { patent: userPatent } = usePatentSystem(publicScore, currentLanguage, t);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(WelcomeModal),
    (Boolean(_unref(progressiveDiscount)?.has_discount))
      ? (_openBlock(), _createBlock(ProgressiveDiscountCard, {
          key: 0,
          discount: _unref(progressiveDiscount)
        }, null, 8, ["discount"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (new Date() <= new Date('2026-04-10T23:58:59'))
        ? (_openBlock(), _createBlock(NewEventBanner, {
            key: 0,
            "next-event": _unref(nextEvent),
            "current-language": _unref(currentLanguage)
          }, null, 8, ["next-event", "current-language"]))
        : _createCommentVNode("", true),
      (new Date() < new Date('2026-11-01T00:00:00'))
        ? (_openBlock(), _createBlock(BlackFridayBanner, { key: 1 }))
        : _createCommentVNode("", true),
      _createVNode(UpgradeMembershipBanner),
      _createVNode(UserProfileCard, {
        user: _unref(user),
        "user-public": _unref(userPublic),
        "user-patent": _unref(userPatent),
        "current-language": _unref(currentLanguage)
      }, null, 8, ["user", "user-public", "user-patent", "current-language"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(ContinuePathwayCard)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(MachinesCard, {
              "last-machine": _unref(lastMachine),
              "current-language": _unref(currentLanguage),
              "free-week-machine": _unref(freeWeekMachine)
            }, null, 8, ["last-machine", "current-language", "free-week-machine"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(NextEventCard, {
              "next-event": _unref(nextEvent),
              "current-language": _unref(currentLanguage),
              loading: _unref(loading)
            }, null, 8, ["next-event", "current-language", "loading"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(AbilitiesRadarCard)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(GoalsCard, {
              challenges_completed: _unref(userPublic)?.challenges_completed,
              total_challenges: _unref(userPublic)?.total_challenges,
              machines_completed: _unref(userPublic)?.machines_completed,
              total_machines: _unref(userPublic)?.total_machines
            }, null, 8, ["challenges_completed", "total_challenges", "machines_completed", "total_machines"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ]))
}
}

})